import { lazy, Suspense, useEffect, useState } from "react";
import classNames from "classnames";

// Hook
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

// Icon
const LazyArrowTop = lazy(
  () => import("assets/icons/glory/arrow-top.svg?react"),
);

const BREAKPOINT = 300;

const GoTop = () => {
  const t = useTranslate();

  const [active, setActive] = useState(false);

  const detectScroll = () => {
    if (window.scrollY > BREAKPOINT) {
      setActive(true);
    } else {
      setActive(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", detectScroll);
    return () => {
      window.removeEventListener("scroll", detectScroll);
    };
  }, []);

  const className = classNames({
    GoTop: true,
    // eslint-disable-next-line camelcase
    GoTop__active: active,
  });

  return (
    <button
      className={className}
      type="button"
      title="Go Top"
      onClick={() =>
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
    >
      <Suspense fallback="">
        <LazyArrowTop />
      </Suspense>
      <span className="GoTop__title">{t("app.scroll.top.button")}</span>
    </button>
  );
};

export default GoTop;
